import { Injectable } from '@angular/core';
import { Storage_Keys } from './storage.keys';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private savedData: any = {};
  constructor() { }

  public getSavedData() {
    this.savedData = {};
    Object.keys(Storage_Keys).forEach(
      (key) => {
        if (key) {
          let data = JSON.parse(JSON.parse(this.get(Storage_Keys[key])));
          if (data) {
            this.savedData[Storage_Keys[key]] = data;
          }
        }
      }
    );

    return this.savedData;
  }

  public set(key: string, data: any) {
    if (!data) {
      return;
    }
    return sessionStorage.setItem(key, JSON.stringify(JSON.stringify(data)));
  }

  private get(key: string) {
    return sessionStorage.getItem(key);
  }

  public removeItem(key: string) {
    return sessionStorage.removeItem(key);
  }

  private clearStorage() {
    sessionStorage.clear();
  }

  public clearStorageForLogout() {
    return new Promise((resolve, reject) => {
      let count = 0
      Object.keys(Storage_Keys).forEach(
        (key) => {
          // if (key && storageKeys[key] !== storageKeys.lastSelectedLanguage && storageKeys[key] !== storageKeys.rememberMe) {
          this.removeItem(Storage_Keys[key]);
          count++;
          // }
        }
      );
      if (count === Object.keys(Storage_Keys).length) {
        resolve(true);
      }
    })
  }
}
